import * as yup from "yup";

export const buyRequestSchema = () => {
  return yup
    .object({
      pay_within: yup.string(),
      offer_ppct: yup.string(),
      offer_tp: yup.string(),
      comments: yup.string(),
    })
    .required();
};
